import React from 'react';
import { Container, Divider, Paper } from "@mui/material";
import AvatarSection from "../UserProfile/components/AvatarSection";
import UserDetails from "../UserProfile/components/UserDetails/UserDetails";
import UserPortfolio from "../UserProfile/components/UserPortfolio/UserPortfolio";
import UserRates from "../UserProfile/components/UserRates/UserRates";
import UserReviews from "../UserProfile/components/UserReviews/UserReviews";
import { useParams } from 'react-router-dom';

const PublicUserProfile = () => {
    const { userId } = useParams();

    return <>
     <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
            <Paper elevation={3} style={{ padding: '2rem' }}>
                <AvatarSection userId={userId} />

                <Divider sx={{ my: 2 }} />

                    <UserDetails userId={userId} />
                    <Divider sx={{ my: 2 }} />
                    <UserPortfolio userId={userId} />
                    <Divider sx={{ my: 2 }} />
                    <UserRates userId={userId} />
                    <Divider sx={{ my: 2 }} />
                    <UserReviews userId={userId} />
            </Paper>
        </Container>
    </>
}

export default PublicUserProfile;